// --- src/components/Header.js ---
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../assets/logo.jpg";

const Header = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  const navLinkClasses = ({ isActive }) =>
    isActive ? "text-blue-600 font-semibold" : "hover:text-blue-600";

  return (
    <header className="fixed top-0 w-full bg-white shadow z-50 p-4 flex justify-between items-center px-6 md:px-20">
      <div className="flex items-center">
        <NavLink to="/">
          <img src={logo} alt="Devan arora" className="h-16 mr-2" />
        </NavLink>
      </div>

      <nav className="hidden md:flex space-x-6 text-gray-700 font-medium">
        {isHome ? (
          <>
            <a href="#services" className="hover:text-blue-600">
              Services
            </a>
            <a href="#listings" className="hover:text-blue-600">
              Listings
            </a>
            <a href="#about" className="hover:text-blue-600">
              About
            </a>
            {/* <a href="#testimonials" className="hover:text-blue-600">
              Testimonials
            </a> */}
            {/* <a href="#contact" className="hover:text-blue-600">
              Contact
            </a> */}
          </>
        ) : (
          <>
            <NavLink to="/" className={navLinkClasses}>
              Home
            </NavLink>
            <NavLink to="/all-listings" className={navLinkClasses}>
              Listings
            </NavLink>
            <NavLink to="/about" className={navLinkClasses}>
              About
            </NavLink>
            <NavLink to="/contact" className={navLinkClasses}>
              Contact
            </NavLink>
          </>
        )}
      </nav>

      {isHome ? (
        <a
          href="https://wa.me/16475504350?text=Hello%2C%20I%E2%80%99m%20interested%20in%20learning%20more%20about%20your%20real%20estate%20offerings.%20Can%20you%20help%20me%3F"
          rel="noopener noreferrer"
          target="_blank"
          className="bg-brand hover:bg-yellow-600 text-white px-4 py-2 rounded transition"
        >
          Contact Me
        </a>
      ) : (
        <NavLink
          to="/contact"
          className="bg-brand hover:bg-yellow-600 text-white px-4 py-2 rounded transition"
        >
          Contact Me
        </NavLink>
      )}
    </header>
  );
};

export default Header;
